import React from 'react';

function LoadingSpinner({ text = 'Loading...', size = 'md' }) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      <div
        className={`${sizeClasses[size]} border-primary/10 border-t-primary rounded-full animate-spin`}
      />
      {text && <p className="text-sm text-on-surface-variant">{text}</p>}
    </div>
  );
}

export default LoadingSpinner;
